import React from 'react';
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-slate-200 bg-white" data-id="element-43" data-mp="3ggapns7ja73v">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-3" data-id="element-44" data-mp="32o4d0g3lai96">
        <div data-id="element-45" data-mp="36pftnw4hjt58">
          <div className="flex items-center gap-2.5" data-id="element-46" data-mp="36oxzd51dvozy">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/098a9b0d-e676-4255-9e5f-030cb51f54a2.jpg" alt="" className="h-9 w-9 rounded-full object-cover" data-id="element-47" data-mp="36ppjnjpj60ax" />
            <span className="font-heading text-lg font-semibold tracking-tight text-slate-900" data-id="element-48" data-mp="3lec9wggp4cgx">
              Flow State <span className="text-sky-600" data-id="element-49" data-mp="3qd6rjf2xfuzg">Plumbers</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm text-slate-600" data-id="element-50" data-mp="29zgl41oc4umn">
            Professional plumbing services — emergency repairs, drain cleaning, installation,
            replacement, and maintenance.
          </p>
        </div>

        <div data-id="element-51" data-mp="3l8qxu8j60rtk">
          <h3 className="font-heading text-sm font-semibold text-slate-900" data-id="element-52" data-mp="3labr7utqu4pu">Contact</h3>
          <ul className="mt-4 space-y-3 text-sm text-slate-600" data-id="element-53" data-mp="3gbio8wc31w3x">
            <li data-id="element-54" data-mp="3v7gejxzbs688">
              <a href="tel:5203000690" className="flex items-center gap-2 hover:text-sky-600" data-id="element-55" data-mp="3v89fgibls1ig">
                <Phone className="h-4 w-4 text-sky-600" data-id="element-56" data-mp="3q83s3ecd9166" />
                520-300-0690
              </a>
            </li>
            <li data-id="element-57" data-mp="81yxik4n004i">
              <a href="mailto:flowstateplumbers@gmail.com" className="flex items-center gap-2 hover:text-sky-600" data-id="element-58" data-mp="81fppw8pas47">
                <Mail className="h-4 w-4 text-sky-600" data-id="element-59" data-mp="ht3a5d6ub8w6" />
                flowstateplumbers@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-2" data-id="element-60" data-mp="cu8sieklzqdn">
              <MapPin className="h-4 w-4 text-sky-600" data-id="element-61" data-mp="qt04nvfwv1z5" />
              Phoenix • Casa Grande • Tucson
            </li>
          </ul>
        </div>

        <div data-id="element-62" data-mp="mthlb43qmyyf">
          <h3 className="font-heading text-sm font-semibold text-slate-900" data-id="element-63" data-mp="mptq80ina4hl">Follow us</h3>
          <ul className="mt-4 space-y-3 text-sm text-slate-600" data-id="element-64" data-mp="twxsxe84bibf">
            <li data-id="element-65" data-mp="yv93xsa5fyv8">
              <a href="https://instagram.com/flowstateplumbers" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-sky-600" data-id="element-66" data-mp="yupl89cod6g5">
                <Instagram className="h-4 w-4 text-sky-600" data-id="element-67" data-mp="1clmd1xys1jm5" />
                @flowstateplumbers
              </a>
            </li>
            <li data-id="element-68" data-mp="1hjw6a30xya54">
              <a href="https://facebook.com/flowstateplumbingaz" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-sky-600" data-id="element-69" data-mp="1hje28k81ermn">
                <Facebook className="h-4 w-4 text-sky-600" data-id="element-70" data-mp="1rgir4rt9p175" />
                @flowstateplumbingaz
              </a>
            </li>
            <li data-id="element-71" data-mp="3t9q7m4km9oum">
              <a href="https://tiktok.com/@flowstateplumbers" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-sky-600" data-id="element-72" data-mp="3tb9p1yi0e5xz">
                <span className="flex h-4 w-4 items-center justify-center text-xs font-bold text-sky-600" data-id="element-73" data-mp="25maqd8z127ap">
                  ♪
                </span>
                @flowstateplumbers
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-200" data-id="element-74" data-mp="2tcy9kqee8jck">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2 px-4 py-6 text-xs text-slate-500 sm:flex-row sm:px-6" data-id="element-75" data-mp="2tbn32itkcxhr">
          <p data-id="element-76" data-mp="2kc8ig002vh56">© {new Date().getFullYear()} Flow State Plumbers. All rights reserved.</p>
          <p data-id="element-77" data-mp="2fezufis90iw0">flowstateplumbers.com</p>
        </div>
      </div>
    </footer>;
}